import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function ServiceCard({ service }) {
  return (
    <Link to={`/services/${service.slug}`} className="group block" data-testid={`service-card-${service.slug}`}>
      <div className="bg-white border border-[#062133]/10 rounded-lg p-6 transition-all hover:-translate-y-1 hover:shadow-md hover:border-[#336DBF]/30 h-full flex flex-col">
        <h3 className="font-semibold text-lg text-[#062133] group-hover:text-[#336DBF] transition-colors">
          {service.name}
        </h3>
        <p className="text-sm text-[#062133]/60 mt-2 line-clamp-2 flex-1">{service.description}</p>
        <div className="mt-4 flex items-center justify-between pt-4 border-t border-[#062133]/5">
          <span className="text-[#336DBF] font-semibold text-sm">{service.prix_moyen}</span>
          <span className="text-[#336DBF] text-xs font-medium flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
            En savoir plus <ArrowRight size={14} />
          </span>
        </div>
      </div>
    </Link>
  );
}
